import type { Item } from 'components/SelectItem/types';

export const parseItemsToIds = (items?: Item[]): string[] => items?.map(item => item.value) ?? [];
